import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ProfileService } from 'src/app/modules/profile/profile.service';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { ActivityService } from '../activity.service';
import { RegisterConsultDialogComponent } from './register-consult-dialog/register-consult-dialog.component';

@Component({
  selector: 'app-consult-user',
  templateUrl: './consult-user.component.html',
  styleUrls: ['./consult-user.component.scss']
})
export class ConsultUserComponent implements OnInit {
  searchForm: FormGroup;
  experties;
  allConsult = null;
  person = [];
  group = [];
  isLoading: boolean = false;
  // ใช้ใน ngmodel เพื่อให้กดได้ปุ่มเดียว
  ls;
  ex;

  categoryList: any[] = []

  constructor(
    public matDialog: MatDialog,
    private activityService: ActivityService,
    private profileService: ProfileService,
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService
  ) {
    this.searchForm = this.fb.group({
      consultType: ['', Validators.required],
      expertie: ['', Validators.required],
      consultDate: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    this.profileService.getExpertie().pipe(
      map(res => {
        this.experties = res.result
        this.gobalFunctionService.setSEO('ตารางกิจกรรม (Consult & Intervention)', 'website', '');
        // console.log(this.experties);
      })
    ).subscribe();
  }

  searching(sf) {
    // // console.log(sf);
    this.isLoading = true;

    let n = new Date();
    let startDate = new Date(new Date(sf.consultDate[0]).setHours(n.getHours()));
    let endDate = new Date(new Date(sf.consultDate[1]).setHours(n.getHours()));
    let oldKeyPerson = '';
    let oldKeyGroup = '';
    n.setDate(n.getDate() + 2);
    this.person = [];
    this.group = [];

    if (sf.consultDate[0] > n) {
      const body = {
        CONSULT_TYPE: sf.consultType,
        EXPERTEI_ID: sf.expertie,
        // EXPERTEI_ID: sf.expertie['EXPERTIE_ID'],
        FROM_DATE: startDate.toISOString().slice(0, 10),
        TO_DATE: endDate.toISOString().slice(0, 10)
      }
      this.activityService.getAllConsultlistByExpertie(body).subscribe(res => {
        // // console.log(res)
        this.allConsult = res.result;

        this.allConsult.person.map((c, i) => {
          c.LIST.map((l, j) => {
            let key = new Date(new Date(l.CONSULT_DATE).setHours(n.getHours())).toISOString().slice(0, 10);
            if (!this.person[i]) {
              this.person[i] = [];
              oldKeyPerson = '';
            }
            if (key !== oldKeyPerson) {
              this.person[i][key] = [];
              oldKeyPerson = key;
            }

            this.person[i][key].push(l);
          })
        })

        this.allConsult.group.map((c, i) => {
          c.LIST.map((l, j) => {
            let key = new Date(new Date(l.CONSULT_DATE).setHours(n.getHours())).toISOString().slice(0, 10);
            if (!this.group[i]) {
              this.group[i] = [];
              oldKeyGroup = '';
            }
            if (key !== oldKeyGroup) {
              this.group[i][key] = [];
              oldKeyGroup = key;
            }

            this.group[i][key].push(l);
          })
        })
        // // console.log(this.person);
        // // console.log(this.group);
        this.isLoading = false;
      });
    } else {
      n.setDate(n.getDate() + 1)
      n.setHours(0, 0, 0)
      alert(`สามารถดู Consult ได้ตั้งแต่วันที่ ${new DatePipe().transform(n.toString(), 'full')} เป็นต้นไป เนื่องจากต้องจองล่วงหน้า 2 วันก่อนเข้ารับคำปรึกษา กรุณาลองใหม่อีกครั้ง`)
      this.isLoading = false;
    }
  }

  getDetailDialog(list, consult, type) {
    // // console.log(list);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.id = 'modalRegister';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      actionBtnText: 'จองเวลา',
      data: list,
      consult: consult,
      consultType: this.searchForm.value.consultType,
      searchData: this.experties[this.searchForm.value.expertie - 1].EXPERTIE_NAME,
      personOrGroup: type
    }

    const modal = this.matDialog.open(RegisterConsultDialogComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status) {
          this.searching(this.searchForm.value);
        }
      })
    ).subscribe()
  }

  checkLength(allConsult) {
    return allConsult.length;
  }

  getTime(date) {
    return new Date(date).getHours();
  }

  formChange() {
    this.allConsult = null;
  }

  setCategory(type) {
    switch (type) {
      case 'Consult': {
        this.categoryList = this.experties.filter(ex => ex.EXPERTIE_NAME === 'พัฒนาการเด็ก' || ex.EXPERTIE_NAME === 'พัฒนาการวัยรุ่น' || ex.EXPERTIE_NAME === 'พัฒนาการผู้สูงวัย');
        break;
      }
      case 'Intervention': {
        this.categoryList = this.experties.filter(ex => ex.EXPERTIE_NAME === 'การประเมินพัฒนาการเด็ก' || ex.EXPERTIE_NAME === 'การเสริมสร้างและส่งเสริมพัฒนาการเด็กเล็ก');
        break;
      }
    }

    this.searchForm.get('expertie').setValue('');
  }
}
